module.exports = "span {\n  display: block;\n  margin: -0.5rem 0 1rem 0;\n  color: var(--red); }\n"